import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Box from '@mui/material/Box';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import LinearProgress from '@mui/material/LinearProgress';
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Carrier from '../../pages/General/Carrier'
import Notification from '../../pages/General/Notification'
import NorowsData from '../../pages/General/NorowsData'
import Printer from '../../pages/General/Printer'
import { doGetRate, resetRateState } from '../../pages/Shipments/NewShipment/rateSlice';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { generateLabel, resetGenerateLabel } from '../../pages/Shipments/NewShipment/createShipmentSlice';
import { dopostDataCreateShipment } from '../../pages/Orders/ordersSlice';

const RateDrawer = ({ visible, reportName, formDataValues, onClose, newOrderFormData, meta, isDuplicateOrder,isReturnOrder, lineItemId, customLineItems, setValues,setNewOrderFormData, setCustomLineItems, setRateDrawervisible = () => { }, setNewOrderCreateDrawerVisible = () => { },isFailedShipment=false,isShipmentCreationFlow=false }) => {
    const dispatch = useDispatch();
    const orders = useSelector(state => state.orders.createShipment);
    const rates = useSelector(state => state.rates);
    const profile = useSelector(state => state.auth);
    const createshipment = useSelector(state => state.createshipment);
    const [rateData, setRateData] = useState([]);
    const [labelShowData, setLabelShowData] = useState(false);
    const [drawer, setDrawer] = useState(true);
    const [snackOpen, setsnackOpen] = useState(false);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [isLabelOpened, setIsLabelOpened] = useState(true)
    const [isFailedLabelPrinted, setIsFailedLabelPrinted] = useState(true)
    const initialFValues = {
        name: '',
        company: '',
        phone: '',
        email: '',
        address: '',
        address2: '',
        city: '',
        postal_code: '',
        country_code: '',
        weight: '',
        box_weight: '',
        actual_weight: '',
        province: '',
        preferred_sender_id: '',
        length: '',
        height: '',
        width: '',
        dimension_unit: 'in',
        weight_unit: 'lb',
        insurance_amount: "",
        choosemeasurement: '',
        preferred_carrier: '',
        preferred_carrier_reference_id: '',
        preferred_service: '',
        sender_reference_no:'',
        return_shipment_sender_id:"",
        shipment_type:"PACKAGE",
        is_signature_required:"",
    }
    const ondrawerclose = () => {
        setDrawer(false)
        onClose(false)
        // dispatch(resetRateState())
        dispatch(resetGenerateLabel())
    }

    const toggleDrawer = (anchor, open) => (event) => {
        let hidedrawer = ''
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
    };

    useEffect(() => {
        if (rates && rates.message && rates.message.length !== 0) {
            setsnackOpen(true)
        }
    }, [rates]);

    const handleClose = () => {
        dispatch(resetRateState())
        setsnackOpen(false)
    };

    function generateCustomRef() {
        // Generate a 24-character hex string
        const randomHex = [...Array(24)]
          .map(() => Math.floor(Math.random() * 16).toString(16))
          .join('');
      
        // Get current datetime in YYYYMMDDHHmmss format
        const now = new Date();
        const datetime =
          now.getFullYear().toString() +
          String(now.getMonth() + 1).padStart(2, '0') +
          String(now.getDate()).padStart(2, '0') +
          String(now.getHours()).padStart(2, '0') +
          String(now.getMinutes()).padStart(2, '0') +
          String(now.getSeconds()).padStart(2, '0');
        // Combine everything
        return `SCREF${randomHex}${datetime}`;
      }

    const generatelabel = (rate_row,status) => {
        let apikey = (profile.profile.api_token) ? profile.profile.api_token : "";
        const formData = formDataValues;
        let referenceno = ""
        let preferred_carrier = ""
        let fetch_rate_request_id=""
        fetch_rate_request_id=rates && rates.data && rates.data.fetch_rate_request_id ? rates.data.fetch_rate_request_id :""
        if(!isDuplicateOrder && newOrderFormData && newOrderFormData.reference && newOrderFormData.reference.no){
            referenceno = newOrderFormData.reference.no
        }

        let order_id_check=""
        let document_reference={}
        if(isReturnOrder){
            order_id_check=(newOrderFormData && newOrderFormData.order && newOrderFormData.order.id)
                ? "R"+newOrderFormData.order.id : ""
            document_reference={
                "doc_id": "",
                "order_id": order_id_check,
                "item_ids": lineItemId,
                "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                "item_reference_id":generateCustomRef(),
                "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
            }
        }else if(isDuplicateOrder){
            document_reference={
                "doc_id": "",
                "order_id": "",
                "item_ids": lineItemId,
                "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                "item_reference_id":formData.item_reference_id,
                "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
            }
        }else{
            order_id_check=(newOrderFormData && newOrderFormData.order && newOrderFormData.order.id)
            ? newOrderFormData.order.id : ""
            document_reference={
                "doc_id": (newOrderFormData && newOrderFormData._id) ? newOrderFormData._id : "",
                "order_id": order_id_check,
                "item_ids": lineItemId,
                "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                "item_reference_id": (newOrderFormData && newOrderFormData._id) ? newOrderFormData._id : formData.item_reference_id,
                "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
            }
        }
        if(status=='LabelFailed'){
            setIsFailedLabelPrinted(false)
            setDrawer(false)
            onClose(false)
            setRateDrawervisible(false)
            setNewOrderCreateDrawerVisible(false)
        }else{
            setIsFailedLabelPrinted(true)
        }
        
        const ratedata = {
            "quantity": "1",
            "referenceno": formData.sender_reference_no!=='' ? formData.sender_reference_no:referenceno,
            "preferred_service": rate_row.id,
            "fetch_rate_request_id":fetch_rate_request_id,
            "request_cheapest_carrier" : false,
            "standard_service_only": false,
            "reference": document_reference,
            "subuser_id":profile.profile.id,
            "shipment_created_method":"FETCH_RATE_CREATE_SHIPMENT"
        }
        if(isShipmentCreationFlow && document_reference && document_reference.is_failed_bulk_order && document_reference.is_failed_bulk_order===true){
            ratedata["bulk_reference_id"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.reference_id
            ratedata["internal_bulk_serial_number"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.serial_number
            ratedata["internal_bulk_serial_number_reference"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.serial_number_reference
        }
        if (customLineItems.length != 0) {
            ratedata["line_items"] = []
        }
        const mergeobjectdata = Object.assign(formData, ratedata);
        dispatch(dopostDataCreateShipment(reportName,profile.profile.id,order_id_check,mergeobjectdata, apikey, meta))
        // dispatch(generateLabel(mergeobjectdata, apikey));
        setLabelShowData(true)
        setIsLabelOpened(false);
    }

    let columns = [
        {
            field: 'service_display_name',
            headerName: 'Service Type',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.service_display_name) {
                    return params.row.service_display_name
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'total_charges',
            headerName: 'Shipping',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 120,
            maxWidth: 120,
            resizable: false,
            renderCell: (params) => {
                if (params.row.total_charges) {
                    return params.row.total_charges
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'action',
            headerName: 'Label',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return <>{isFailedShipment && <div className="hide--outline"><Button disabled={orders.loading} variant="outlined"  style={{ margin: '0 15px' }} onClick={(event) => {
                    generatelabel(params.row,"LabelFailed")
                }
                }> <AddCircleOutlineOutlinedIcon style={{
                    paddingRight: '10px'
                }} /> Create </Button></div>
                }
                <div className="hide--outline"><Button disabled={orders.loading} variant="outlined" onClick={(event) => {
                    generatelabel(params.row,"LabelSuccess")
                }
                }> <AddCircleOutlineOutlinedIcon style={{
                    paddingRight: '10px'
                }} /> Create + Print </Button></div></>

            }
        }
    ];
    if(profile && profile.profile && (profile.profile.hide_carrier === false)){
        columns.splice(0, 0, {
            field: 'carrier_display_name',
            headerName: 'Carrier Name',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            renderCell: (params) => {
                if (params.row.carrier_display_name) {
                    return params.row.carrier_display_name
                } else {
                    return "-"
                }
            }
        })
    }
    if (profile && profile.profile && (
        (typeof profile.profile.is_sc_ddp_enabled !== "undefined" && profile.profile.is_sc_ddp_enabled == true) || 
        (typeof profile.profile.is_sc_myparcel_ddp_enabled !== "undefined" && profile.profile.is_sc_myparcel_ddp_enabled == true)
    )) {
        let duties_length = columns.length - 1;
        columns.splice(duties_length, 0, {
            field: 'currency_code',
            headerName: 'Duties',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 120,
            maxWidth: 120,
            resizable: false,
            renderCell: (params) => {
                // 2. Updated render condition with OR (||)
                const isDdpEnabled = profile.profile.is_sc_ddp_enabled === true || profile.profile.is_sc_myparcel_ddp_enabled === true;
                
                if (isDdpEnabled && params.row.duty_charges?.total_charge !== undefined) {
                    return params.row.duty_charges.total_charge;
                } else {
                    return "-";
                }
            }
        });
    }

    if (
        profile && 
        profile.profile && 
        typeof profile.profile.sum_shipping_and_duties !== "undefined" && 
        profile.profile.sum_shipping_and_duties === true && (
            (typeof profile.profile.is_sc_ddp_enabled !== "undefined" && profile.profile.is_sc_ddp_enabled === true) || 
            (typeof profile.profile.is_sc_myparcel_ddp_enabled !== "undefined" && profile.profile.is_sc_myparcel_ddp_enabled === true)
        )
    ) {
        // Locate the 'Duties' column dynamically to place the 'Total' column immediately after it
        const dutiesColumnIndex = columns.findIndex(col => col.field === 'currency_code');
        
        if (dutiesColumnIndex !== -1) {
            columns.splice(dutiesColumnIndex + 1, 0, {
                field: 'shipping_and_duties_total',
                headerName: 'Total',
                headerClassName: 'super-app-theme--header',
                flex: 1,
                minWidth: 120,
                maxWidth: 120,
                resizable: false,
                renderCell: (params) => {
                    // Safe Check: If params or params.row is missing completely
                    if (!params || !params.row) return "-";

                    // 1. Safe parsing for Shipping Charges
                    let shippingCharges = 0;
                    if (params.row.total_charges !== undefined && params.row.total_charges !== null) {
                        shippingCharges = parseFloat(String(params.row.total_charges).replace(/[^\d.-]/g, '')) || 0;
                    }

                    // 2. Safe parsing for Duty Charges (Uses optional chaining to avoid nested property errors)
                    let dutyCharges = 0;
                    if (params.row.duty_charges?.total_charge !== undefined && params.row.duty_charges?.total_charge !== null) {
                        dutyCharges = parseFloat(String(params.row.duty_charges.total_charge).replace(/[^\d.-]/g, '')) || 0;
                    }

                    // 3. Fallback: If both fields are totally missing or empty in row object, show hyphen
                    if (!params.row.hasOwnProperty('total_charges') && !params.row.hasOwnProperty('duty_charges')) {
                        return "-";
                    }

                    const combinedTotal = shippingCharges + dutyCharges;
                    return combinedTotal.toFixed(2);
                }
            });
        }
    }
    useEffect(() => {
        if (orders && orders.notification && orders.notification.messageContent && orders.notification.messageContent[0] === 'Shipment Created Successfully' && visible == true && isLabelOpened == false && isFailedLabelPrinted==true) {
            setIsLabelOpened(true);
            setPrintUrl(orders && orders.message && orders.message.label_carrier)
            setIsPrinted(false)
            setDrawer(false)
            onClose(false)
            setRateDrawervisible(false)
            setNewOrderCreateDrawerVisible(false)
            setCustomLineItems([])
            setValues(initialFValues)
            setNewOrderFormData("")
        }
    }, [orders]);

    return (
        <>
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />
            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        ondrawerclose();
                    }
                }}
                PaperProps={{
                    sx: { width: "70%" },
                }}
            >
                <div style={{ padding: "0 30px" }}>
                {(rates && rates.notification && rates.notification.show && rates.notification.show===true) &&
                            <Notification
                                is_open={rates.notification.show}
                                messageType={rates.notification.messageType}
                                messages={rates.notification.messageContent}
                                handleClose={() => dispatch(resetRateState())}
                            />
                        }

                    {(createshipment.notification.messageContent.length === 0 || createshipment.notification.messageType === 'error') &&
                        <>
                            <Card sx={{ minWidth: 1000, margin: '20px 0' }} className="sc--cardhead--details">
                                <CardHeader title='Rates' action={
                                    <div>
                                        <IconButton aria-label="settings" onClick={ondrawerclose}>
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                } />
                                <Divider />
                            </Card>

                            <DataGrid sx={{ width: '100%' }}
                                disableRowSelectionOnClick={true}
                                getRowId={(row) => row.id}
                                rows={rates?.data || []}
                                columns={columns}
                                columnVisibilityModel={{
                                    action: reportName === 'DASHBOARD_FETCH_RATES' ? false : true, // Hides the action column
                                    total_charges: profile && profile.profile && profile.profile.hide_rate === true  ? false : true, 
                                }}
                                autoHeight={true}
                                hideFooter={true}
                                slots={{
                                    loadingOverlay: LinearProgress,
                                    NorowsData
                                }}
                                loading={rates && rates.loading || orders && orders.loading}
                            />
                        </>
                    }
                    {(createshipment.notification.messageContent).length !== 0 && (createshipment.notification.messageType !== 'error') &&
                        <>
                            <Card sx={{ minWidth: 1000, margin: '20px 0' }} className="sc--cardhead--details">
                                <CardHeader title='Labels' action={
                                    <div>
                                        <IconButton aria-label="settings" onClick={ondrawerclose}>
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                } />
                                <Divider />
                            </Card>
                            <Card sx={{ minWidth: 1000, margin: '20px 0' }} className="sc--cardhead--details">
                                <Divider />
                                <div className="" style={{ margin: 'auto' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '20px' }}>
                                        <CheckCircleIcon style={{ textAlign: 'center', fontSize: '40px', color: 'green' }} />
                                    </div>
                                    <h2 style={{ textAlign: 'center' }}>Successfully generated label</h2>
                                    <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                                        <p style={{ marginBottom: '20px' }}>Tracking Number: {createshipment && createshipment.order && createshipment.order.trackingnumber}</p>
                                        <p style={{ marginBottom: '20px' }}>Carrier: {createshipment && createshipment.order && createshipment.order.carrier_name}</p>
                                        <a href={createshipment && createshipment.order && createshipment.order.label_carrier} target='_blank'
                                            style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', textDecoration: 'unset' }}>
                                            <RemoveRedEyeIcon />View Label
                                            </a>
                                    </div>
                                </div>

                            </Card>
                        </>
                    }
                </div>
            </Drawer >
        </>
    )
}


export default RateDrawer;